window.onload = function () {
    const currentLocation = location.pathname;

    // Function to activate the main menu item
    function activateMainMenuItem(submenuLink) {
        const buddhaMenuItem = submenuLink.closest('.mm-submenu')?.closest('.buddha-menu-item');
        if (buddhaMenuItem) {
            const mainMenuLink = buddhaMenuItem.querySelector('.header__menu-item');
            mainMenuLink?.classList.add('active');
        }
    }

    // Handle submenu and main menu item activation based on URL
    document.querySelectorAll('.mm-submenu li a').forEach(submenuLink => {
        const path = new URL(submenuLink.href).pathname;
        if (path === currentLocation) {
            submenuLink.classList.add('active');
            activateMainMenuItem(submenuLink);
        }
    });

    document.querySelectorAll('.list-menu .buddha-menu-item > .header__menu-item').forEach(link => {
        if (link.getAttribute('href') === currentLocation) {
            link.classList.add('active');
        }
    });
};

// FAQ Add class
document.querySelectorAll('.accordion-list .accordion .accordion__title').forEach(item => {
    item.addEventListener('click', function () {
        this.classList.toggle('active');
    });
});